<template>
  <div>
    <table width='100%'>
      <tbody>
        <tr>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.owner'
              :rules='[rules.required]'
              label='Owner'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
          </td>
        </tr>

        <tr>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.bill_to'
              label='Billing contact'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('bill_to')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

        <tr>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.sales_contact'
              label='Sales contact'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('sales_contact')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

 
        <tr v-if='value.division_obj.division === "Irrigation"'>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.notices_contact'
              label='Notices contact'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('notices_contact')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

       <tr v-if='value.division_obj.division === "Irrigation"'>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.install_contact'
              label='Install contact'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('install_contact')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

        <tr>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.site_contact'
              :label='((value.division_obj.division !== "Irrigation") ? "Site" : "Service") + " contact"'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('site_contact')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

        <tr v-if='value.division_obj.division === "Irrigation"'>
          <td>
            <v-autocomplete
              :items='contacts'
              item-value='id'
              item-text='name_display'
              v-model='value.secondary_site_contact'
              label='Secondary Service contact'
            ></v-autocomplete>
          </td>
          <td class='text-right'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  icon
                  color='info'
                  v-on='on'
                  @click="matchOwnerContact('secondary_site_contact')"
                >
                  <v-icon>mdi-account-supervisor</v-icon>
                </v-btn>
              </template>
              <span>
                Make same as owner
              </span>
            </v-tooltip>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
export default {
  name: 'estimate-contacts-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    },
    contacts: {
      required: true
    }
  },
  methods: {
    matchOwnerContact (contact_type) {
      switch(contact_type) {
        case 'bill_to':
          this.value.bill_to = this.value.owner
          break;
        case 'sales_contact':
          this.value.sales_contact = this.value.owner
          break;
        case 'notices_contact':
          this.value.notices_contact = this.value.owner
          break;
        case 'install_contact':
          this.value.install_contact = this.value.owner
          break;
        case 'site_contact':
          this.value.site_contact = this.value.owner
          break;
        case 'secondary_site_contact':
          this.value.secondary_site_contact = this.value.owner
          break;
        default:
          break;
        }
    }
  }
}
</script>
